var map = {
	"./en/about.json": 79732,
	"./en/auth.json": 15021,
	"./en/bigGameBash2025.json": 85272,
	"./en/bigGameBash2026.json": 83189,
	"./en/blog.json": 39607,
	"./en/calendar.json": 29785,
	"./en/careerFair.json": 68471,
	"./en/careers.json": 15050,
	"./en/chaseTheAce2024.json": 50957,
	"./en/checkout.json": 8027,
	"./en/chineseNewYear2025.json": 95778,
	"./en/chineseNewYear2026.json": 30035,
	"./en/defaultHeroCarousel.json": 41838,
	"./en/dining.json": 33562,
	"./en/diningPromos.json": 67294,
	"./en/drunkenDragonClosingModal.json": 58459,
	"./en/dynamicGoogleForm.json": 3965,
	"./en/eatAndPlay/breakfast.json": 24916,
	"./en/eatAndPlay/eatAndPlay.json": 2990,
	"./en/eatAndPlay/extras.json": 50316,
	"./en/eatAndPlay/main.json": 60022,
	"./en/egd.json": 9593,
	"./en/egdWelcomeJackpotParty2024.json": 99393,
	"./en/emailConfirmation.json": 63996,
	"./en/emailVerification.json": 49826,
	"./en/entertainment.json": 96111,
	"./en/etg.json": 18059,
	"./en/eventFinished.json": 44395,
	"./en/existingUser.json": 10617,
	"./en/fightQuest61.json": 24978,
	"./en/footer.json": 38172,
	"./en/fraudWarningModal.json": 80158,
	"./en/highHands.json": 10331,
	"./en/highHands/highHandApril2025.json": 30548,
	"./en/highHands/highHandDecember2024.json": 49978,
	"./en/highHands/highHandJuly2025.json": 98460,
	"./en/highHands/highHandJune2025.json": 1326,
	"./en/highHands/highHandNovember2025.json": 14524,
	"./en/highHands/highHandSummer2026.json": 99046,
	"./en/highHands/hotSeatsOctober2025.json": 33006,
	"./en/highHands/megaHighHandJuly2025.json": 91002,
	"./en/highHands/megaHighHandJune2025.json": 24872,
	"./en/highHands/nationalPokerDay2025.json": 45396,
	"./en/highHands/nationalPokerDay2026.json": 77825,
	"./en/hotels.json": 71140,
	"./en/merch.json": 10262,
	"./en/mercierBridge.json": 30711,
	"./en/modal.json": 26560,
	"./en/myAccount.json": 6316,
	"./en/nav.json": 75128,
	"./en/newUser.json": 64564,
	"./en/pastEvents.json": 10722,
	"./en/pastEvents/pastEvents2011.json": 48610,
	"./en/pastEvents/pastEvents2012.json": 72915,
	"./en/pastEvents/pastEvents2013.json": 60272,
	"./en/pastEvents/pastEvents2014.json": 74457,
	"./en/pastEvents/pastEvents2015.json": 55870,
	"./en/pastEvents/pastEvents2016.json": 13727,
	"./en/pastEvents/pastEvents2017.json": 99884,
	"./en/pastEvents/pastEvents2018.json": 27877,
	"./en/pastEvents/pastEvents2019.json": 21818,
	"./en/pastEvents/pastEvents2020.json": 91430,
	"./en/pastEvents/pastEvents2021.json": 19233,
	"./en/pastEvents/pastEvents2022.json": 95316,
	"./en/pastEvents/pastEvents2023.json": 43623,
	"./en/pastEvents/pastEvents2024.json": 86634,
	"./en/pastEvents/pastEvents2025.json": 43509,
	"./en/pastEvents/pastEvents2026.json": 38648,
	"./en/playersGuide.json": 56193,
	"./en/playgroundCares.json": 69172,
	"./en/poker.json": 27340,
	"./en/pokerPlayers.json": 9922,
	"./en/pokerRules.json": 68395,
	"./en/pokerTableFilmingPolicy.json": 35588,
	"./en/privacy.json": 57005,
	"./en/promoDrawsPage.json": 93018,
	"./en/promotions.json": 15361,
	"./en/promotions/downloadAndWin2026.json": 79893,
	"./en/promotions/egd/birthdayBash2025.json": 22971,
	"./en/promotions/egd/cashnadoSpring2026.json": 80895,
	"./en/promotions/egd/clubElite.json": 270,
	"./en/promotions/egd/easterEggStravaganza2025.json": 83091,
	"./en/promotions/egd/easterEggStravaganza2026.json": 48834,
	"./en/promotions/egd/followForFreePlay.json": 74873,
	"./en/promotions/egd/gpFreePlay2025.json": 85463,
	"./en/promotions/egd/gpFreePlay2026.json": 85174,
	"./en/promotions/egd/hauntedCarnival2025.json": 43685,
	"./en/promotions/egd/jackpotParty.json": 43609,
	"./en/promotions/egd/ladiesNight2025.json": 10000,
	"./en/promotions/egd/mscCruiseApril2026.json": 51943,
	"./en/promotions/egd/multiplierFridays2025.json": 7287,
	"./en/promotions/egd/nclCruiseMarch2026.json": 46140,
	"./en/promotions/egd/nuitElite.json": 32982,
	"./en/promotions/egd/openFortuneFreePlay2026.json": 90934,
	"./en/promotions/egd/podcastFreePlayDynamic2026.json": 76000,
	"./en/promotions/egd/rcgCruiseJuly2026.json": 36826,
	"./en/promotions/egd/rcgCruiseJuly2026Rsvp.json": 81875,
	"./en/promotions/egd/scavengerHunt2025.json": 56191,
	"./en/promotions/egd/scavengerHuntDynamic2025.json": 4422,
	"./en/promotions/egd/spinAndSpoilMom2025.json": 76951,
	"./en/promotions/egd/spinAndSpoilMom2026.json": 76662,
	"./en/promotions/egd/winAMillion2025.json": 66221,
	"./en/promotions/egd/winningWednesday.json": 19239,
	"./en/promotions/poker/common/tbcbCommon.json": 24212,
	"./en/promotions/poker/multiMillionaireMaker2025.json": 85047,
	"./en/promotions/poker/multiMillionaireMakerAugust2025.json": 4870,
	"./en/promotions/poker/multiMillionaireMakerSeptember2025.json": 21396,
	"./en/promotions/poker/tripleBarrelCashBlast2025.json": 19156,
	"./en/promotions/poker/tripleBarrelCashBlast2025AnniversaryEdition.json": 39428,
	"./en/promotions/poker/tripleBarrelCashBlast2026.json": 3553,
	"./en/promotions/poker/tripleBarrelCashBlastFebruary2026.json": 33775,
	"./en/promotions/poker/tripleBarrelCashBlastMarch2026.json": 24160,
	"./en/promotions/poker/wsopcPlaygroundMay2026CreatorChampionship.json": 27763,
	"./en/pseudoRoutes.json": 94259,
	"./en/requestPassword.json": 76333,
	"./en/restaurants.json": 61773,
	"./en/restaurants/allYouCanEat2025.json": 52647,
	"./en/restaurants/dragonAfterHours2025.json": 64471,
	"./en/restaurants/dragonDiceNights.json": 33581,
	"./en/roomsForRent.json": 23143,
	"./en/routes.json": 51937,
	"./en/saintPatricksDay2025.json": 76800,
	"./en/saintPatricksDay2026.json": 7933,
	"./en/seo.json": 72004,
	"./en/smsTermsConditions.json": 57865,
	"./en/subscription.json": 76182,
	"./en/successfulPayment.json": 66741,
	"./en/tierMatch2026.json": 62606,
	"./en/toast.json": 29762,
	"./en/tournament.json": 52052,
	"./en/tournaments.json": 74913,
	"./en/tournaments/14yearAnniversarySeries2024/chipCountsMainEvent.json": 60239,
	"./en/tournaments/14yearAnniversarySeries2024/chipCountsMysteryBounty.json": 40082,
	"./en/tournaments/14yearAnniversarySeries2024/leaderboardTabs.json": 83973,
	"./en/tournaments/14yearAnniversarySeries2024/schedule.json": 89707,
	"./en/tournaments/14yearAnniversarySeries2024/tabs.json": 4030,
	"./en/tournaments/15yearAnniversarySeries2025/chipCountsMainEvent.json": 92657,
	"./en/tournaments/15yearAnniversarySeries2025/chipCountsMegaStack.json": 87640,
	"./en/tournaments/15yearAnniversarySeries2025/chipCountsMysteryBounty.json": 9636,
	"./en/tournaments/15yearAnniversarySeries2025/leaderboardTabs.json": 23343,
	"./en/tournaments/15yearAnniversarySeries2025/schedule.json": 36041,
	"./en/tournaments/15yearAnniversarySeries2025/tabs.json": 56556,
	"./en/tournaments/examples/reorderedComponents.json": 81844,
	"./en/tournaments/examples/repeatedComponents.json": 29328,
	"./en/tournaments/examples/variantCustomization.json": 51960,
	"./en/tournaments/moneyMakerTour2025/aboutChris.json": 3136,
	"./en/tournaments/moneyMakerTour2025/chipCountsMainEvent.json": 48021,
	"./en/tournaments/moneyMakerTour2025/chipCountsMonsterStackMysteryBounty.json": 43182,
	"./en/tournaments/moneyMakerTour2025/chipCountsMysteryBounty.json": 17336,
	"./en/tournaments/moneyMakerTour2025/chipCountsPg300MegaStack.json": 27298,
	"./en/tournaments/moneyMakerTour2025/leaderboardTabs.json": 39859,
	"./en/tournaments/moneyMakerTour2025/meetUpGame.json": 18780,
	"./en/tournaments/moneyMakerTour2025/schedule.json": 14149,
	"./en/tournaments/moneyMakerTour2025/tabs.json": 82456,
	"./en/tournaments/msptCanadianPokerChampionship2025/chipCountsMainEvent.json": 28980,
	"./en/tournaments/msptCanadianPokerChampionship2025/chipCountsMegaStack.json": 82117,
	"./en/tournaments/msptCanadianPokerChampionship2025/chipCountsMysteryBounty.json": 69013,
	"./en/tournaments/msptCanadianPokerChampionship2025/leaderboardTabs.json": 76686,
	"./en/tournaments/msptCanadianPokerChampionship2025/schedule.json": 29166,
	"./en/tournaments/msptCanadianPokerChampionship2025/tabs.json": 2059,
	"./en/tournaments/powerWeeksJune2025/chipCountsMegaStack.json": 66932,
	"./en/tournaments/powerWeeksJune2025/chipCountsMonsterStack.json": 11100,
	"./en/tournaments/powerWeeksJune2025/chipCountsMysteryBounty.json": 69864,
	"./en/tournaments/powerWeeksJune2025/leaderboardTabs.json": 66819,
	"./en/tournaments/powerWeeksJune2025/schedule.json": 34837,
	"./en/tournaments/powerWeeksJune2025/tabs.json": 19016,
	"./en/tournaments/springBreakPowerWeeks2025/chipCountsMegaStack.json": 18908,
	"./en/tournaments/springBreakPowerWeeks2025/chipCountsMonsterStack.json": 97236,
	"./en/tournaments/springBreakPowerWeeks2025/chipCountsMysteryBounty.json": 59920,
	"./en/tournaments/springBreakPowerWeeks2025/leaderboardTabs.json": 2187,
	"./en/tournaments/springBreakPowerWeeks2025/schedule.json": 11565,
	"./en/tournaments/springBreakPowerWeeks2025/tabs.json": 20384,
	"./en/tournaments/springBreakPowerWeeks2026/chipCountsMegaStack.json": 80461,
	"./en/tournaments/springBreakPowerWeeks2026/chipCountsMonsterStack.json": 86743,
	"./en/tournaments/springBreakPowerWeeks2026/chipCountsMysteryBounty.json": 16253,
	"./en/tournaments/springBreakPowerWeeks2026/leaderboardTabs.json": 14870,
	"./en/tournaments/springBreakPowerWeeks2026/schedule.json": 56454,
	"./en/tournaments/springBreakPowerWeeks2026/tabs.json": 44227,
	"./en/tournaments/springChampionship2023/qualified.json": 30522,
	"./en/tournaments/springChampionship2023/schedule.json": 94337,
	"./en/tournaments/summerMillion2026/schedule.json": 75033,
	"./en/tournaments/worldCupOfCards2025/chipCountsMainEvent.json": 33207,
	"./en/tournaments/worldCupOfCards2025/chipCountsPg300MegaStack.json": 85620,
	"./en/tournaments/worldCupOfCards2025/leaderboardTabs.json": 13645,
	"./en/tournaments/worldCupOfCards2025/schedule.json": 71555,
	"./en/tournaments/worldCupOfCards2025/tabs.json": 82102,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyHighRoller.json": 66858,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyMainSatellites.json": 6101,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyPartypoker.json": 66608,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/schedule.json": 68706,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/tabs.json": 26815,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/travelFlight.json": 43949,
	"./en/tournaments/wptDeepStacksPlaygroundPoker2020/travelHotels.json": 76672,
	"./en/tournaments/wptGlobalOctoberMillions2023/chipCountsAccumulator.json": 80867,
	"./en/tournaments/wptGlobalOctoberMillions2023/chipCountsMainEvent.json": 86026,
	"./en/tournaments/wptGlobalOctoberMillions2023/chipCountsMegaAccumulator.json": 39637,
	"./en/tournaments/wptGlobalOctoberMillions2023/leaderboardTabs.json": 7380,
	"./en/tournaments/wptGlobalOctoberMillions2023/meetUpGame.json": 83209,
	"./en/tournaments/wptGlobalOctoberMillions2023/megaAccumulator.json": 37319,
	"./en/tournaments/wptGlobalOctoberMillions2023/megaAccumulatorSatellites.json": 31953,
	"./en/tournaments/wptGlobalOctoberMillions2023/pg400Accumulator.json": 43194,
	"./en/tournaments/wptGlobalOctoberMillions2023/schedule.json": 24720,
	"./en/tournaments/wptGlobalOctoberMillions2023/tabs.json": 65045,
	"./en/tournaments/wptGlobalSummerMillion2025/chipCountsHighRoller.json": 87599,
	"./en/tournaments/wptGlobalSummerMillion2025/chipCountsMainEvent.json": 62082,
	"./en/tournaments/wptGlobalSummerMillion2025/chipCountsMysteryBounty.json": 64459,
	"./en/tournaments/wptGlobalSummerMillion2025/leaderboardTabs.json": 91916,
	"./en/tournaments/wptGlobalSummerMillion2025/promotionsOnlineEvents.json": 36021,
	"./en/tournaments/wptGlobalSummerMillion2025/schedule.json": 18360,
	"./en/tournaments/wptGlobalSummerMillion2025/tabs.json": 20317,
	"./en/tournaments/wptGlobalWinterClassic2026/chipCountsHighRoller.json": 44580,
	"./en/tournaments/wptGlobalWinterClassic2026/chipCountsMainEvent.json": 83999,
	"./en/tournaments/wptGlobalWinterClassic2026/chipCountsMysteryBounty.json": 16002,
	"./en/tournaments/wptGlobalWinterClassic2026/leaderboardTabs.json": 89973,
	"./en/tournaments/wptGlobalWinterClassic2026/promotionsOnlineEvents.json": 43070,
	"./en/tournaments/wptGlobalWinterClassic2026/schedule.json": 65243,
	"./en/tournaments/wptGlobalWinterClassic2026/tabs.json": 74286,
	"./en/tournaments/wptMontreal2024/chipCounts500.json": 31335,
	"./en/tournaments/wptMontreal2024/chipCountsHighRoller.json": 78108,
	"./en/tournaments/wptMontreal2024/chipCountsMainEvent.json": 11623,
	"./en/tournaments/wptMontreal2024/chipCountsPrime.json": 25063,
	"./en/tournaments/wptMontreal2024/leaderboardTabs.json": 56189,
	"./en/tournaments/wptMontreal2024/liveFeed.json": 74240,
	"./en/tournaments/wptMontreal2024/meetUpGame-new.json": 90253,
	"./en/tournaments/wptMontreal2024/meetUpGame.json": 31110,
	"./en/tournaments/wptMontreal2024/schedule.json": 14355,
	"./en/tournaments/wptMontreal2024/tabs.json": 43046,
	"./en/tournaments/wptPlaygroundOctober2024/chipAndShare.json": 16037,
	"./en/tournaments/wptPlaygroundOctober2024/chipCounts500.json": 37836,
	"./en/tournaments/wptPlaygroundOctober2024/chipCountsHighRoller.json": 5313,
	"./en/tournaments/wptPlaygroundOctober2024/chipCountsMainEvent.json": 41260,
	"./en/tournaments/wptPlaygroundOctober2024/chipCountsPrime.json": 21980,
	"./en/tournaments/wptPlaygroundOctober2024/leaderboardTabs.json": 88070,
	"./en/tournaments/wptPlaygroundOctober2024/meetUpGame.json": 54627,
	"./en/tournaments/wptPlaygroundOctober2024/promotionsWptGlobale.json": 18628,
	"./en/tournaments/wptPlaygroundOctober2024/schedule.json": 85430,
	"./en/tournaments/wptPlaygroundOctober2024/tabs.json": 75475,
	"./en/tournaments/wptPlaygroundPokerTournament2018/frameYourVictory.json": 89296,
	"./en/tournaments/wptPlaygroundPokerTournament2018/qualifyMainSatellites.json": 98760,
	"./en/tournaments/wptPlaygroundPokerTournament2018/qualifyPartypoker.json": 24950,
	"./en/tournaments/wptPlaygroundPokerTournament2018/schedule.json": 59381,
	"./en/tournaments/wptPlaygroundPokerTournament2018/tabs.json": 43048,
	"./en/tournaments/wptPlaygroundPokerTournament2018/travelFlight.json": 63130,
	"./en/tournaments/wptPlaygroundPokerTournament2018/travelHotels.json": 28259,
	"./en/tournaments/wptPlaygroundPokerTournament2018/wpt2018promotions.json": 68508,
	"./en/tournaments/wptPlaygroundPokerTournament2019/qualifyMainSatellites.json": 80371,
	"./en/tournaments/wptPlaygroundPokerTournament2019/qualifyPartypoker.json": 11965,
	"./en/tournaments/wptPlaygroundPokerTournament2019/qualifyPartypokerWpt500.json": 9573,
	"./en/tournaments/wptPlaygroundPokerTournament2019/qualifyWpt500.json": 60044,
	"./en/tournaments/wptPlaygroundPokerTournament2019/schedule.json": 20004,
	"./en/tournaments/wptPlaygroundPokerTournament2019/tabs.json": 87961,
	"./en/tournaments/wptPlaygroundPokerTournament2019/travelFlight.json": 33111,
	"./en/tournaments/wptPlaygroundPokerTournament2019/travelHotels.json": 50466,
	"./en/tournaments/wptPlaygroundPokerTournament2019/wpt2019promotions.json": 1732,
	"./en/tournaments/wptWinterClassic2024/chipCountsHighRoller.json": 58293,
	"./en/tournaments/wptWinterClassic2024/chipCountsMainEvent.json": 93800,
	"./en/tournaments/wptWinterClassic2024/chipCountsPg350.json": 5276,
	"./en/tournaments/wptWinterClassic2024/lastLonger.json": 78566,
	"./en/tournaments/wptWinterClassic2024/leaderboardTabs.json": 23682,
	"./en/tournaments/wptWinterClassic2024/meetUpGame.json": 67199,
	"./en/tournaments/wptWinterClassic2024/onlineSatellites.json": 31386,
	"./en/tournaments/wptWinterClassic2024/schedule.json": 13530,
	"./en/tournaments/wptWinterClassic2024/tabs.json": 48951,
	"./en/tournaments/wptWorldChampionship2023/schedule.json": 25171,
	"./en/tournaments/wptWorldChampionship2024/schedule.json": 7596,
	"./en/tournaments/wsopSuperCircuitCanada2026/schedule.json": 23947,
	"./en/tournaments/wsopcMontrealGGPoker2025/schedule.json": 44658,
	"./en/tournaments/wsopcPlayground2024/chipCounts5050MysteryBounty.json": 63834,
	"./en/tournaments/wsopcPlayground2024/chipCountsCloser.json": 83742,
	"./en/tournaments/wsopcPlayground2024/chipCountsColossus.json": 66861,
	"./en/tournaments/wsopcPlayground2024/chipCountsFlipNgo.json": 19377,
	"./en/tournaments/wsopcPlayground2024/chipCountsHighRoller.json": 73476,
	"./en/tournaments/wsopcPlayground2024/chipCountsMainEvent.json": 63391,
	"./en/tournaments/wsopcPlayground2024/chipCountsMonsterStack.json": 29698,
	"./en/tournaments/wsopcPlayground2024/chipCountsNoLimitHoldem.json": 68145,
	"./en/tournaments/wsopcPlayground2024/leaderboardTabs.json": 29973,
	"./en/tournaments/wsopcPlayground2024/mainEventSatellites.json": 98291,
	"./en/tournaments/wsopcPlayground2024/schedule.json": 41691,
	"./en/tournaments/wsopcPlayground2024/tabs.json": 35150,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipAndShare.json": 17575,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCounts5050MysteryBounty.json": 63283,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsColossus.json": 97534,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsFlipNgo.json": 42528,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsHighRoller.json": 73503,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsMainEvent.json": 914,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsMonsterStack.json": 80897,
	"./en/tournaments/wsopcPlaygroundAugust2024/chipCountsNoLimitHoldem.json": 53184,
	"./en/tournaments/wsopcPlaygroundAugust2024/leaderboardTabs.json": 42460,
	"./en/tournaments/wsopcPlaygroundAugust2024/mainEventSatellites.json": 1990,
	"./en/tournaments/wsopcPlaygroundAugust2024/mysteryBountyLuxon.json": 83387,
	"./en/tournaments/wsopcPlaygroundAugust2024/schedule.json": 26376,
	"./en/tournaments/wsopcPlaygroundAugust2024/tabs.json": 38797,
	"./en/tournaments/wsopcPlaygroundFall2025/schedule.json": 62037,
	"./en/tournaments/wsopcPlaygroundMay2026/eventInfo.json": 62955,
	"./en/tournaments/wsopcPlaygroundMay2026/schedule.json": 98948,
	"./en/tournaments/wsopcPlaygroundMay2026/tabs.json": 34649,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/frameYourVictory.json": 28035,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/qualifyFrenzySatellites.json": 40714,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/qualifyLiveSatellites.json": 11266,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/qualifyMegaSatellites.json": 94934,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/qualifyPartypoker.json": 58611,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/schedule.json": 52722,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/tabs.json": 9615,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/travelFlight.json": 27005,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/travelHotels.json": 65168,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/wsopc2018promotionsLastLonger.json": 36767,
	"./en/tournaments/wsopcPlaygroundPokerTournament2018/wsopc2018promotionsPpl.json": 58214,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/promotionsRakeFreeMainEvent.json": 6310,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/promotionsWsopcMonterrey.json": 51057,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/qualifyMainSatellites.json": 67066,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/qualifyPartypoker.json": 228,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/qualifyPartypokerColossus.json": 92241,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/schedule.json": 6315,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/tabs.json": 382,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/travelFlight.json": 14584,
	"./en/tournaments/wsopcPlaygroundPokerTournament2019/travelHotels.json": 68921,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsColossus.json": 92167,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsFlipNgo.json": 20215,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsHighRoller.json": 84294,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsMainEvent.json": 45521,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsMonsterStackEvent15.json": 71342,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsMonsterStackEvent2.json": 15434,
	"./en/tournaments/wsopcPlaygroundSpring2025/chipCountsNoLimitHoldem.json": 79307,
	"./en/tournaments/wsopcPlaygroundSpring2025/leaderboardTabs.json": 52079,
	"./en/tournaments/wsopcPlaygroundSpring2025/schedule.json": 6985,
	"./en/tournaments/wsopcPlaygroundSpring2025/tabs.json": 53420,
	"./en/tournaments/wsopcPlaygroundSpring2026/eventInfo.json": 7889,
	"./en/tournaments/wsopcPlaygroundSpring2026/schedule-new.json": 74345,
	"./en/tournaments/wsopcPlaygroundSpring2026/schedule.json": 85938,
	"./en/tournaments/wsopcPlaygroundSpring2026/tabs.json": 72911,
	"./en/translation.json": 44362,
	"./en/ultimateDad2025.json": 14806,
	"./en/ultimateDad2026.json": 15095,
	"./en/unsubscribed.json": 30628,
	"./en/valentines2025.json": 587,
	"./en/valentines2026.json": 45914,
	"./en/wsopcForm.json": 78313,
	"./fr/about.json": 57387,
	"./fr/auth.json": 9368,
	"./fr/bigGameBash2025.json": 22811,
	"./fr/bigGameBash2026.json": 42698,
	"./fr/blog.json": 31486,
	"./fr/calendar.json": 18764,
	"./fr/careerFair.json": 15458,
	"./fr/careers.json": 48845,
	"./fr/chaseTheAce2024.json": 27458,
	"./fr/checkout.json": 95458,
	"./fr/chineseNewYear2025.json": 97863,
	"./fr/chineseNewYear2026.json": 76422,
	"./fr/defaultHeroCarousel.json": 94189,
	"./fr/dining.json": 7555,
	"./fr/diningPromos.json": 60279,
	"./fr/drunkenDragonClosingModal.json": 15612,
	"./fr/dynamicGoogleForm.json": 76346,
	"./fr/eatAndPlay/breakfast.json": 48205,
	"./fr/eatAndPlay/eatAndPlay.json": 97229,
	"./fr/eatAndPlay/extras.json": 69271,
	"./fr/eatAndPlay/main.json": 12201,
	"./fr/egd.json": 18418,
	"./fr/egdWelcomeJackpotParty2024.json": 73784,
	"./fr/emailConfirmation.json": 44127,
	"./fr/emailVerification.json": 65413,
	"./fr/entertainment.json": 6468,
	"./fr/etg.json": 25572,
	"./fr/eventFinished.json": 29024,
	"./fr/existingUser.json": 67488,
	"./fr/fightQuest61.json": 76915,
	"./fr/footer.json": 7401,
	"./fr/fraudWarningModal.json": 92337,
	"./fr/highHands.json": 2652,
	"./fr/highHands/highHandApril2025.json": 11679,
	"./fr/highHands/highHandDecember2024.json": 44851,
	"./fr/highHands/highHandJuly2025.json": 89089,
	"./fr/highHands/highHandJune2025.json": 49803,
	"./fr/highHands/highHandNovember2025.json": 43389,
	"./fr/highHands/highHandSummer2026.json": 94687,
	"./fr/highHands/hotSeatsOctober2025.json": 49269,
	"./fr/highHands/megaHighHandJuly2025.json": 66647,
	"./fr/highHands/megaHighHandJune2025.json": 73221,
	"./fr/highHands/nationalPokerDay2025.json": 69853,
	"./fr/highHands/nationalPokerDay2026.json": 50624,
	"./fr/hotels.json": 61409,
	"./fr/merch.json": 8673,
	"./fr/mercierBridge.json": 66368,
	"./fr/modal.json": 21283,
	"./fr/myAccount.json": 68931,
	"./fr/nav.json": 33091,
	"./fr/newUser.json": 72983,
	"./fr/pastEvents.json": 66863,
	"./fr/pastEvents/pastEvents2011.json": 23245,
	"./fr/pastEvents/pastEvents2012.json": 98480,
	"./fr/pastEvents/pastEvents2013.json": 39027,
	"./fr/pastEvents/pastEvents2014.json": 72062,
	"./fr/pastEvents/pastEvents2015.json": 76249,
	"./fr/pastEvents/pastEvents2016.json": 21740,
	"./fr/pastEvents/pastEvents2017.json": 58879,
	"./fr/pastEvents/pastEvents2018.json": 98650,
	"./fr/pastEvents/pastEvents2019.json": 73029,
	"./fr/pastEvents/pastEvents2020.json": 72329,
	"./fr/pastEvents/pastEvents2021.json": 81518,
	"./fr/pastEvents/pastEvents2022.json": 27983,
	"./fr/pastEvents/pastEvents2023.json": 21916,
	"./fr/pastEvents/pastEvents2024.json": 75453,
	"./fr/pastEvents/pastEvents2025.json": 50354,
	"./fr/pastEvents/pastEvents2026.json": 25603,
	"./fr/playersGuide.json": 69632,
	"./fr/playgroundCares.json": 18407,
	"./fr/poker.json": 63447,
	"./fr/pokerPlayers.json": 33751,
	"./fr/pokerRules.json": 49730,
	"./fr/pokerTableFilmingPolicy.json": 10803,
	"./fr/privacy.json": 19134,
	"./fr/promoDrawsPage.json": 9671,
	"./fr/promotions.json": 13344,
	"./fr/promotions/downloadAndWin2026.json": 67826,
	"./fr/promotions/egd/birthdayBash2025.json": 74384,
	"./fr/promotions/egd/cashnadoSpring2026.json": 93736,
	"./fr/promotions/egd/clubElite.json": 71203,
	"./fr/promotions/egd/easterEggStravaganza2025.json": 78060,
	"./fr/promotions/egd/easterEggStravaganza2026.json": 32569,
	"./fr/promotions/egd/followForFreePlay.json": 41740,
	"./fr/promotions/egd/gpFreePlay2025.json": 86528,
	"./fr/promotions/egd/gpFreePlay2026.json": 31933,
	"./fr/promotions/egd/hauntedCarnival2025.json": 30244,
	"./fr/promotions/egd/jackpotParty.json": 70686,
	"./fr/promotions/egd/ladiesNight2025.json": 75249,
	"./fr/promotions/egd/mscCruiseApril2026.json": 98136,
	"./fr/promotions/egd/multiplierFridays2025.json": 96734,
	"./fr/promotions/egd/nclCruiseMarch2026.json": 83955,
	"./fr/promotions/egd/nuitElite.json": 91463,
	"./fr/promotions/egd/openFortuneFreePlay2026.json": 55903,
	"./fr/promotions/egd/podcastFreePlayDynamic2026.json": 51847,
	"./fr/promotions/egd/rcgCruiseJuly2026.json": 98603,
	"./fr/promotions/egd/rcgCruiseJuly2026Rsvp.json": 35586,
	"./fr/promotions/egd/scavengerHunt2025.json": 14654,
	"./fr/promotions/egd/scavengerHuntDynamic2025.json": 21445,
	"./fr/promotions/egd/spinAndSpoilMom2025.json": 51442,
	"./fr/promotions/egd/spinAndSpoilMom2026.json": 72771,
	"./fr/promotions/egd/winAMillion2025.json": 3220,
	"./fr/promotions/egd/winningWednesday.json": 11104,
	"./fr/promotions/poker/common/tbcbCommon.json": 53821,
	"./fr/promotions/poker/multiMillionaireMaker2025.json": 61890,
	"./fr/promotions/poker/multiMillionaireMakerAugust2025.json": 71907,
	"./fr/promotions/poker/multiMillionaireMakerSeptember2025.json": 14615,
	"./fr/promotions/poker/tripleBarrelCashBlast2025.json": 47813,
	"./fr/promotions/poker/tripleBarrelCashBlast2025AnniversaryEdition.json": 94261,
	"./fr/promotions/poker/tripleBarrelCashBlast2026.json": 61896,
	"./fr/promotions/poker/tripleBarrelCashBlastFebruary2026.json": 37094,
	"./fr/promotions/poker/tripleBarrelCashBlastMarch2026.json": 45479,
	"./fr/promotions/poker/wsopcPlaygroundMay2026CreatorChampionship.json": 10546,
	"./fr/pseudoRoutes.json": 34830,
	"./fr/requestPassword.json": 60466,
	"./fr/restaurants.json": 48954,
	"./fr/restaurants/allYouCanEat2025.json": 13566,
	"./fr/restaurants/dragonAfterHours2025.json": 71074,
	"./fr/restaurants/dragonDiceNights.json": 27852,
	"./fr/roomsForRent.json": 15926,
	"./fr/routes.json": 34352,
	"./fr/saintPatricksDay2025.json": 99909,
	"./fr/saintPatricksDay2026.json": 24104,
	"./fr/seo.json": 86279,
	"./fr/smsTermsConditions.json": 76680,
	"./fr/subscription.json": 51423,
	"./fr/successfulPayment.json": 21442,
	"./fr/tierMatch2026.json": 11209,
	"./fr/toast.json": 93889,
	"./fr/tournament.json": 73961,
	"./fr/tournaments.json": 19270,
	"./fr/tournaments/14yearAnniversarySeries2024/chipCountsMainEvent.json": 33584,
	"./fr/tournaments/14yearAnniversarySeries2024/chipCountsMysteryBounty.json": 60241,
	"./fr/tournaments/14yearAnniversarySeries2024/leaderboardTabs.json": 91370,
	"./fr/tournaments/14yearAnniversarySeries2024/schedule.json": 99730,
	"./fr/tournaments/14yearAnniversarySeries2024/tabs.json": 8815,
	"./fr/tournaments/15yearAnniversarySeries2025/chipCountsMainEvent.json": 64566,
	"./fr/tournaments/15yearAnniversarySeries2025/chipCountsMegaStack.json": 1275,
	"./fr/tournaments/15yearAnniversarySeries2025/chipCountsMysteryBounty.json": 90031,
	"./fr/tournaments/15yearAnniversarySeries2025/leaderboardTabs.json": 60096,
	"./fr/tournaments/15yearAnniversarySeries2025/schedule.json": 25924,
	"./fr/tournaments/15yearAnniversarySeries2025/tabs.json": 58329,
	"./fr/tournaments/moneyMakerTour2025/aboutChris.json": 16887,
	"./fr/tournaments/moneyMakerTour2025/chipCountsMainEvent.json": 9692,
	"./fr/tournaments/moneyMakerTour2025/chipCountsMonsterStackMysteryBounty.json": 61687,
	"./fr/tournaments/moneyMakerTour2025/chipCountsMysteryBounty.json": 15101,
	"./fr/tournaments/moneyMakerTour2025/chipCountsPg300MegaStack.json": 40833,
	"./fr/tournaments/moneyMakerTour2025/leaderboardTabs.json": 9942,
	"./fr/tournaments/moneyMakerTour2025/meetUpGame.json": 87059,
	"./fr/tournaments/moneyMakerTour2025/schedule.json": 966,
	"./fr/tournaments/moneyMakerTour2025/tabs.json": 21347,
	"./fr/tournaments/msptCanadianPokerChampionship2025/chipCountsMainEvent.json": 24103,
	"./fr/tournaments/msptCanadianPokerChampionship2025/chipCountsMegaStack.json": 24066,
	"./fr/tournaments/msptCanadianPokerChampionship2025/chipCountsMysteryBounty.json": 71434,
	"./fr/tournaments/msptCanadianPokerChampionship2025/leaderboardTabs.json": 6141,
	"./fr/tournaments/msptCanadianPokerChampionship2025/schedule.json": 77587,
	"./fr/tournaments/msptCanadianPokerChampionship2025/tabs.json": 52070,
	"./fr/tournaments/powerWeeksJune2025/chipCountsMegaStack.json": 58645,
	"./fr/tournaments/powerWeeksJune2025/chipCountsMonsterStack.json": 67471,
	"./fr/tournaments/powerWeeksJune2025/chipCountsMysteryBounty.json": 4453,
	"./fr/tournaments/powerWeeksJune2025/leaderboardTabs.json": 94750,
	"./fr/tournaments/powerWeeksJune2025/schedule.json": 31614,
	"./fr/tournaments/powerWeeksJune2025/tabs.json": 67163,
	"./fr/tournaments/springBreakPowerWeeks2025/chipCountsMegaStack.json": 41911,
	"./fr/tournaments/springBreakPowerWeeks2025/chipCountsMonsterStack.json": 58505,
	"./fr/tournaments/springBreakPowerWeeks2025/chipCountsMysteryBounty.json": 73235,
	"./fr/tournaments/springBreakPowerWeeks2025/leaderboardTabs.json": 74644,
	"./fr/tournaments/springBreakPowerWeeks2025/schedule.json": 58640,
	"./fr/tournaments/springBreakPowerWeeks2025/tabs.json": 341,
	"./fr/tournaments/springBreakPowerWeeks2026/chipCountsMegaStack.json": 37394,
	"./fr/tournaments/springBreakPowerWeeks2026/chipCountsMonsterStack.json": 89994,
	"./fr/tournaments/springBreakPowerWeeks2026/chipCountsMysteryBounty.json": 18074,
	"./fr/tournaments/springBreakPowerWeeks2026/leaderboardTabs.json": 92077,
	"./fr/tournaments/springBreakPowerWeeks2026/schedule.json": 36227,
	"./fr/tournaments/springBreakPowerWeeks2026/tabs.json": 32278,
	"./fr/tournaments/springChampionship2023/qualified.json": 31911,
	"./fr/tournaments/springChampionship2023/schedule.json": 86654,
	"./fr/tournaments/summerMillion2026/schedule.json": 73200,
	"./fr/tournaments/worldCupOfCards2025/chipCountsMainEvent.json": 78752,
	"./fr/tournaments/worldCupOfCards2025/chipCountsPg300MegaStack.json": 61373,
	"./fr/tournaments/worldCupOfCards2025/leaderboardTabs.json": 49434,
	"./fr/tournaments/worldCupOfCards2025/schedule.json": 51394,
	"./fr/tournaments/worldCupOfCards2025/tabs.json": 47231,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyHighRoller.json": 451,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyMainSatellites.json": 37788,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/qualifyPartypoker.json": 36466,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/schedule.json": 13649,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/tabs.json": 59476,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/travelFlight.json": 64766,
	"./fr/tournaments/wptDeepStacksPlaygroundPoker2020/travelHotels.json": 51767,
	"./fr/tournaments/wptGlobalOctoberMillions2023/chipCountsAccumulator.json": 3906,
	"./fr/tournaments/wptGlobalOctoberMillions2023/chipCountsMainEvent.json": 34911,
	"./fr/tournaments/wptGlobalOctoberMillions2023/chipCountsMegaAccumulator.json": 41760,
	"./fr/tournaments/wptGlobalOctoberMillions2023/leaderboardTabs.json": 36757,
	"./fr/tournaments/wptGlobalOctoberMillions2023/meetUpGame.json": 36046,
	"./fr/tournaments/wptGlobalOctoberMillions2023/megaAccumulator.json": 86378,
	"./fr/tournaments/wptGlobalOctoberMillions2023/megaAccumulatorSatellites.json": 76524,
	"./fr/tournaments/wptGlobalOctoberMillions2023/pg400Accumulator.json": 59985,
	"./fr/tournaments/wptGlobalOctoberMillions2023/schedule.json": 72795,
	"./fr/tournaments/wptGlobalOctoberMillions2023/tabs.json": 11054,
	"./fr/tournaments/wptGlobalSummerMillion2025/chipCountsHighRoller.json": 12040,
	"./fr/tournaments/wptGlobalSummerMillion2025/chipCountsMainEvent.json": 41723,
	"./fr/tournaments/wptGlobalSummerMillion2025/chipCountsMysteryBounty.json": 96110,
	"./fr/tournaments/wptGlobalSummerMillion2025/leaderboardTabs.json": 58753,
	"./fr/tournaments/wptGlobalSummerMillion2025/promotionsOnlineEvents.json": 9178,
	"./fr/tournaments/wptGlobalSummerMillion2025/schedule.json": 55455,
	"./fr/tournaments/wptGlobalSummerMillion2025/tabs.json": 61506,
	"./fr/tournaments/wptGlobalWinterClassic2026/chipCountsHighRoller.json": 79379,
	"./fr/tournaments/wptGlobalWinterClassic2026/chipCountsMainEvent.json": 3118,
	"./fr/tournaments/wptGlobalWinterClassic2026/chipCountsMysteryBounty.json": 42567,
	"./fr/tournaments/wptGlobalWinterClassic2026/leaderboardTabs.json": 37944,
	"./fr/tournaments/wptGlobalWinterClassic2026/promotionsOnlineEvents.json": 16001,
	"./fr/tournaments/wptGlobalWinterClassic2026/schedule.json": 94124,
	"./fr/tournaments/wptGlobalWinterClassic2026/tabs.json": 94721,
	"./fr/tournaments/wptMontreal2024/chipCounts500.json": 75232,
	"./fr/tournaments/wptMontreal2024/chipCountsHighRoller.json": 91997,
	"./fr/tournaments/wptMontreal2024/chipCountsMainEvent.json": 92192,
	"./fr/tournaments/wptMontreal2024/chipCountsPrime.json": 18216,
	"./fr/tournaments/wptMontreal2024/leaderboardTabs.json": 64314,
	"./fr/tournaments/wptMontreal2024/liveFeed.json": 97129,
	"./fr/tournaments/wptMontreal2024/meetUpGame.json": 66759,
	"./fr/tournaments/wptMontreal2024/schedule.json": 25442,
	"./fr/tournaments/wptMontreal2024/tabs.json": 70367,
	"./fr/tournaments/wptPlaygroundOctober2024/chipAndShare.json": 3638,
	"./fr/tournaments/wptPlaygroundOctober2024/chipCounts500.json": 83997,
	"./fr/tournaments/wptPlaygroundOctober2024/chipCountsHighRoller.json": 26246,
	"./fr/tournaments/wptPlaygroundOctober2024/chipCountsMainEvent.json": 55025,
	"./fr/tournaments/wptPlaygroundOctober2024/chipCountsPrime.json": 29057,
	"./fr/tournaments/wptPlaygroundOctober2024/leaderboardTabs.json": 95087,
	"./fr/tournaments/wptPlaygroundOctober2024/meetUpGame.json": 66520,
	"./fr/tournaments/wptPlaygroundOctober2024/promotionsWptGlobale.json": 72243,
	"./fr/tournaments/wptPlaygroundOctober2024/schedule.json": 6281,
	"./fr/tournaments/wptPlaygroundOctober2024/tabs.json": 67436,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/frameYourVictory.json": 47451,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/qualifyMainSatellites.json": 68829,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/qualifyPartypoker.json": 90075,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/schedule.json": 71914,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/tabs.json": 46951,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/travelFlight.json": 96661,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/travelHotels.json": 43400,
	"./fr/tournaments/wptPlaygroundPokerTournament2018/wpt2018promotions.json": 98265,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/qualifyMainSatellites.json": 23666,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/qualifyPartypoker.json": 49804,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/qualifyPartypokerWpt500.json": 89808,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/qualifyWpt500.json": 31385,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/schedule.json": 50499,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/tabs.json": 68022,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/travelFlight.json": 78256,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/travelHotels.json": 14417,
	"./fr/tournaments/wptPlaygroundPokerTournament2019/wpt2019promotions.json": 47033,
	"./fr/tournaments/wptWinterClassic2024/chipCountsHighRoller.json": 29726,
	"./fr/tournaments/wptWinterClassic2024/chipCountsMainEvent.json": 31801,
	"./fr/tournaments/wptWinterClassic2024/chipCountsPg350.json": 41605,
	"./fr/tournaments/wptWinterClassic2024/lastLonger.json": 8357,
	"./fr/tournaments/wptWinterClassic2024/leaderboardTabs.json": 60119,
	"./fr/tournaments/wptWinterClassic2024/meetUpGame.json": 85904,
	"./fr/tournaments/wptWinterClassic2024/onlineSatellites.json": 5269,
	"./fr/tournaments/wptWinterClassic2024/schedule.json": 8545,
	"./fr/tournaments/wptWinterClassic2024/tabs.json": 89924,
	"./fr/tournaments/wptWorldChampionship2023/schedule.json": 11800,
	"./fr/tournaments/wptWorldChampionship2024/schedule.json": 89063,
	"./fr/tournaments/wsopSuperCircuitCanada2026/schedule.json": 23248,
	"./fr/tournaments/wsopcMontrealGGPoker2025/schedule.json": 20101,
	"./fr/tournaments/wsopcPlayground2024/chipCounts5050MysteryBounty.json": 59521,
	"./fr/tournaments/wsopcPlayground2024/chipCountsCloser.json": 48339,
	"./fr/tournaments/wsopcPlayground2024/chipCountsColossus.json": 95244,
	"./fr/tournaments/wsopcPlayground2024/chipCountsFlipNgo.json": 83034,
	"./fr/tournaments/wsopcPlayground2024/chipCountsHighRoller.json": 37013,
	"./fr/tournaments/wsopcPlayground2024/chipCountsMainEvent.json": 45512,
	"./fr/tournaments/wsopcPlayground2024/chipCountsMonsterStack.json": 27619,
	"./fr/tournaments/wsopcPlayground2024/chipCountsNoLimitHoldem.json": 51374,
	"./fr/tournaments/wsopcPlayground2024/leaderboardTabs.json": 6306,
	"./fr/tournaments/wsopcPlayground2024/mainEventSatellites.json": 24808,
	"./fr/tournaments/wsopcPlayground2024/schedule.json": 76442,
	"./fr/tournaments/wsopcPlayground2024/tabs.json": 9527,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipAndShare.json": 33722,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCounts5050MysteryBounty.json": 10968,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsColossus.json": 94323,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsFlipNgo.json": 96723,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsHighRoller.json": 6170,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsMainEvent.json": 48989,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsMonsterStack.json": 55332,
	"./fr/tournaments/wsopcPlaygroundAugust2024/chipCountsNoLimitHoldem.json": 34447,
	"./fr/tournaments/wsopcPlaygroundAugust2024/leaderboardTabs.json": 31355,
	"./fr/tournaments/wsopcPlaygroundAugust2024/mainEventSatellites.json": 82397,
	"./fr/tournaments/wsopcPlaygroundAugust2024/mysteryBountyLuxon.json": 97526,
	"./fr/tournaments/wsopcPlaygroundAugust2024/schedule.json": 71645,
	"./fr/tournaments/wsopcPlaygroundAugust2024/tabs.json": 39504,
	"./fr/tournaments/wsopcPlaygroundFall2025/schedule.json": 57624,
	"./fr/tournaments/wsopcPlaygroundMay2026/eventInfo.json": 63926,
	"./fr/tournaments/wsopcPlaygroundMay2026/schedule.json": 18299,
	"./fr/tournaments/wsopcPlaygroundMay2026/tabs.json": 36174,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/frameYourVictory.json": 65552,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/qualifyFrenzySatellites.json": 26667,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/qualifyLiveSatellites.json": 52391,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/qualifyMegaSatellites.json": 9435,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/qualifyPartypoker.json": 57910,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/schedule.json": 84149,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/tabs.json": 84200,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/travelFlight.json": 74618,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/travelHotels.json": 78339,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/wsopc2018promotionsLastLonger.json": 52314,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2018/wsopc2018promotionsPpl.json": 31273,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/promotionsRakeFreeMainEvent.json": 92811,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/promotionsWsopcMonterrey.json": 93970,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/qualifyMainSatellites.json": 71315,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/qualifyPartypoker.json": 73373,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/qualifyPartypokerColossus.json": 14256,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/schedule.json": 33060,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/tabs.json": 87385,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/travelFlight.json": 60343,
	"./fr/tournaments/wsopcPlaygroundPokerTournament2019/travelHotels.json": 57698,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsColossus.json": 46182,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsFlipNgo.json": 81800,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsHighRoller.json": 39991,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsMainEvent.json": 85626,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsMonsterStackEvent15.json": 73481,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsMonsterStackEvent2.json": 52607,
	"./fr/tournaments/wsopcPlaygroundSpring2025/chipCountsNoLimitHoldem.json": 6504,
	"./fr/tournaments/wsopcPlaygroundSpring2025/leaderboardTabs.json": 15940,
	"./fr/tournaments/wsopcPlaygroundSpring2025/schedule.json": 27488,
	"./fr/tournaments/wsopcPlaygroundSpring2025/tabs.json": 9669,
	"./fr/tournaments/wsopcPlaygroundSpring2026/eventInfo.json": 66750,
	"./fr/tournaments/wsopcPlaygroundSpring2026/schedule.json": 53555,
	"./fr/tournaments/wsopcPlaygroundSpring2026/tabs.json": 75014,
	"./fr/translation.json": 9633,
	"./fr/ultimateDad2025.json": 42669,
	"./fr/ultimateDad2026.json": 87152,
	"./fr/unsubscribed.json": 58629,
	"./fr/valentines2025.json": 67746,
	"./fr/valentines2026.json": 92051,
	"./fr/wsopcForm.json": 71858
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40511;
module.exports = webpackAsyncContext;